import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';
import {Provider} from "react-redux";

import {store } from "./store";

import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import { Route, Switch, BrowserRouter } from 'react-router-dom';
import './modules/lfui-dist/lf.js';

import Contact from './pages/ContactPage';
import Apartment from './pages/ApartmentPage';
import Partner from './pages/PartnerPage';
import Summary from './pages/SummarySignPage';
import Confirmation from './pages/ConfirmationPage';

import Navbar from './components/layout/Navbar';
import FooterBottom from './components/layout/FooterBottom';
import history from './router/history';

ReactDOM.render(
    <Provider store={store}>
        <div className="App">
        <Navbar />
        <div className="container mt-4">
            <BrowserRouter history={history} basename={process.env.LF_BASE_HREF}>
                <Switch>
                    <Route exact path="/"> <div><h1>404</h1></div> </Route>
                    <Route exact path="/kund"> <div><h1>404</h1></div> </Route>
                    <Route exact path="/intern"> <div><h1>404</h1></div> </Route>
                    
                    <Route exact path="/kund/:id" component={Contact}  />
                    <Route path="/kund/:id/apartment" component={Apartment} />
                    <Route path="/kund/:id/summary" component={Summary} />
                    
                    <Route exact path="/intern/:id" component={Partner}  />
                    <Route path="/intern/:id/summary" component={Summary} />
                    
                    <Route path="/confirmation" component={Confirmation} />
                </Switch>
            </BrowserRouter>
        </div>
        <FooterBottom />
        </div>
    </Provider>,
    document.getElementById('root'));

serviceWorker.unregister();
